












import {
  CurrencyInputOptions,
  parse,
  useCurrencyInput,
} from "vue-currency-input";
import { defineComponent, watch } from "@vue/composition-api";

/**
 * IMPORTANT - This is using Vue 3's new Composition API which has a backwards
 * compatible library. It was required for the latest vue-currency-input library
 *
 * @see https://github.com/vuejs/composition-api
 */
export default defineComponent({
  name: "AmountInput",
  props: {
    label: String,
    value: Number,
    options: Object,
  },
  setup(props: any, { emit }) {
    const { inputRef, setOptions, setValue } = useCurrencyInput(props.options);

    watch(
      () => props.value, // Vue 2: props.value
      (value: number) => {
        setValue(value);
      }
    );

    watch(
      () => props.options,
      (options: CurrencyInputOptions) => {
        setOptions(options);
      }
    );

    const onChange = (value: string) => {
      const num = parse(value, props.options);
      emit("change-amount", num ? Math.round(num * 100) : null);
    };

    return { inputRef, onChange };
  },
  methods: {},
});
